import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";

function ASuperAdmin() {
  const users = [
    { id: 1, name: "John Mathew", role: "HR Manager" },
    { id: 2, name: "Sophia Williams", role: "Employee" },
    { id: 3, name: "David Johnson", role: "Team Lead" },
    { id: 4, name: "Michael Brown", role: "Team Lead" },
    { id: 5, name: "Emma Davis", role: "Team Lead" },
    { id: 6, name: "James Wilson", role: "Team Lead" },
    { id: 7, name: "Olivia Taylor", role: "HR Executive" },
    { id: 8, name: "William Anderson", role: "Project Manager" },
    { id: 9, name: "Ava Thomas", role: "Business Analyst" },
    { id: 10, name: "Noah Martin", role: "Developer" },
  ];

  const modules = [
    { key: "Employee Overview", icon: "fa-users" },
    { key: "Report", icon: "fa-file-alt" },
    { key: "Attendance Management", icon: "fa-calendar-check" },
    { key: "Leave Management", icon: "fa-plane-departure" },
    { key: "Payroll Overview", icon: "fa-money-bill" },
    { key: "Recruitment", icon: "fa-user-plus" },
    { key: "Performance Management", icon: "fa-chart-line" },
    { key: "Project Tracking", icon: "fa-tasks" },
    { key: "Alerts", icon: "fa-bell" },
    { key: "Reports & Analytics", icon: "fa-chart-bar" },
    { key: "Admin Controls", icon: "fa-user-shield" },
  ];

  const defaultPermissions = {
    "Employee Overview": true,
    Report: false,
    "Attendance Management": false,
    "Leave Management": false,
    "Payroll Overview": false,
    Recruitment: false,
    "Performance Management": false,
    "Project Tracking": false,
    Alerts: false,
    "Reports & Analytics": false,
    "Admin Controls": false,
  };

  const [permissions, setPermissions] = useState({
    1: {
      "Employee Overview": true,
      Report: true,
      "Attendance Management": true,
      "Leave Management": true,
      "Payroll Overview": true,
      Recruitment: true,
      "Performance Management": true,
      "Project Tracking": false,
      Alerts: true,
      "Reports & Analytics": true,
      "Admin Controls": false,
    },

    2: defaultPermissions,

    3: {
      "Employee Overview": true,
      Report: true,
      "Attendance Management": true,
      "Leave Management": true,
      "Payroll Overview": true,
      Recruitment: true,
      "Performance Management": true,
      "Project Tracking": true,
      Alerts: true,
      "Reports & Analytics": true,
      "Admin Controls": true,
    },
  });

  const [selectedUser, setSelectedUser] = useState(users[0]);
  const [activeModule, setActiveModule] = useState("Employee Overview");
  const [search, setSearch] = useState("");
  const [darkMode, setDarkMode] = useState(false);

  const [tempPermissions, setTempPermissions] = useState(
    permissions[selectedUser.id] || defaultPermissions,
  );

  const filteredUsers = users.filter((u) =>
    u.name.toLowerCase().includes(search.toLowerCase()),
  );

  // USER CHANGE
  const handleUserChange = (user) => {
    setSelectedUser(user);
    // Load the saved permissions for this user
    const userPermissions = permissions[user.id];
    setTempPermissions(userPermissions || defaultPermissions);
  };

  // TOGGLE
  const handleToggle = (module) => {
    setTempPermissions((prev) => {
      const updated = {
        ...prev,
        [module]: !prev[module],
      };

      // REPORT OFF panna auto hide
      if (
        module === "Report" &&
        updated["Report"] === false &&
        activeModule === "Report"
      ) {
        setActiveModule("Employee Overview");
      }

      return updated;
    });
  };

  // ENABLE ALL
  const enableAll = () => {
    const updated = {};

    modules.forEach((m) => {
      updated[m.key] = true;
    });

    setTempPermissions(updated);

    toast.success("All permissions enabled");
  };

  // DISABLE ALL
  const disableAll = () => {
    const updated = {};

    modules.forEach((m) => {
      updated[m.key] = false;
    });

    setTempPermissions(updated);

    toast.error("All permissions disabled");
  };

  // SUBMIT
  const handleSubmit = () => {
    const updatedPermissions = {
      ...permissions,
      [selectedUser.id]: tempPermissions,
    };

    setPermissions(updatedPermissions);
    // Refresh tempPermissions to reflect the saved state
    setTempPermissions(updatedPermissions[selectedUser.id]);

    toast.success("Permissions updated successfully for " + selectedUser.name);
  };

  return (
    <div
      className={`d-flex ${darkMode ? "bg-dark text-white" : "bg-light"}`}
      style={{ minHeight: "100vh" }}
    >
      <ToastContainer />

      {/* SIDEBAR */}
      <div
        className={`p-3 ${
          darkMode ? "bg-black text-white" : "bg-dark text-white"
        }`}
        style={{ width: "280px" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="text-warning">HRMS</h4>

          <button
            className="btn btn-sm btn-outline-light"
            onClick={() => setDarkMode(!darkMode)}
          >
            <i className={`fas ${darkMode ? "fa-sun" : "fa-moon"}`}></i>
          </button>
        </div>

        <h6 className="mb-3">Accessible Modules</h6>
        {/* SIDEBAR MODULES */}
        {modules.map((m) =>
          (permissions[selectedUser.id] || defaultPermissions)[m.key] ? (
            <div
              key={m.key}
              onClick={() => setActiveModule(m.key)}
              className={`p-2 mb-2 rounded ${
                activeModule === m.key ? "bg-primary" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <i className={`fas ${m.icon} me-2`}></i>
              {m.key}
            </div>
          ) : null,
        )}
      </div>

      {/* MAIN */}
      <div className="flex-grow-1 p-4">
        {/* TOP */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Super Admin Dashboard</h2>
        </div>

        {/* DASHBOARD CARDS */}
        <div className="row mb-4">
          <div className="col-md-3">
            <div className="card shadow border-0 bg-primary text-white p-3">
              <h3>150</h3>
              <p>Total Employees</p>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card shadow border-0 bg-success text-white p-3">
              <h3>120</h3>
              <p>Present Today</p>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card shadow border-0 bg-warning text-dark p-3">
              <h3>12</h3>
              <p>Pending Leaves</p>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card shadow border-0 bg-danger text-white p-3">
              <h3>5</h3>
              <p>Alerts</p>
            </div>
          </div>
        </div>

        {/* USERS */}
        <div className="card border-0 shadow rounded-4 p-3 mb-3">
          <h5 className="fw-bold mb-3">Select Employee</h5>

          <input
            type="text"
            className="form-control mb-3"
            placeholder="Search employee..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <div
            className="list-group mb-3"
            style={{ maxHeight: "250px", overflowY: "auto" }}
          >
            {filteredUsers.map((u) => (
              <label
                key={u.id}
                className={`list-group-item d-flex align-items-center gap-3 rounded-3 mb-2 border ${
                  selectedUser?.id === u.id ? "border-primary bg-light" : ""
                }`}
                style={{ cursor: "pointer" }}
              >
                <input
                  type="radio"
                  className="form-check-input m-0"
                  name="employee"
                  checked={selectedUser?.id === u.id}
                  onChange={() => handleUserChange(u)}
                />

                <div
                  className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold"
                  style={{ width: "40px", height: "40px" }}
                >
                  {u.name.charAt(0)}
                </div>

                <div>
                  <div className="fw-semibold">{u.name}</div>

                  <small className="text-muted">{u.role}</small>
                </div>
              </label>
            ))}
          </div>

          {selectedUser && (
            <div className="alert alert-success mb-0">
              Selected: <strong>{selectedUser.name}</strong>
            </div>
          )}
        </div>

        {/* ENABLE / DISABLE */}
        <div className="d-flex justify-content-end mb-2">
          <button className="btn btn-success me-2" onClick={enableAll}>
            Enable All
          </button>

          <button className="btn btn-danger" onClick={disableAll}>
            Disable All
          </button>
        </div>

        {/* ACCESS CONTROL */}
        <div className="card p-4 shadow-sm border-0 mb-4 mt-4">
          <h4>🔐 Access Control - {selectedUser?.name}</h4>

          <div className="row g-3">
            {modules.map((m) => {
              const isActive = tempPermissions[m.key];

              return (
                <div className="col-md-3" key={m.key}>
                  <div
                    className="p-3 rounded text-center shadow-sm"
                    style={{
                      background: isActive ? "#d1e7dd" : "#f8f9fa",
                      border: isActive
                        ? "2px solid #198754"
                        : "1px solid #dee2e6",
                    }}
                  >
                    <i
                      className={`fas ${m.icon} fa-2x mb-3`}
                      style={{
                        color: isActive ? "#198754" : "#6c757d",
                      }}
                    ></i>

                    <h6>{m.key}</h6>

                    <div className="form-check form-switch d-flex justify-content-center mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isActive || false}
                        onChange={() => handleToggle(m.key)}
                      />
                    </div>

                    <span
                      className={`badge rounded-pill mt-2 ${
                        isActive ? "bg-success" : "bg-secondary"
                      }`}
                    >
                      {isActive ? "Enabled" : "Disabled"}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          {/* SUBMIT */}
          <div className="text-end mt-4">
            <button className="btn btn-primary px-4" onClick={handleSubmit}>
              Save Changes
            </button>
          </div>
        </div>

        {/* MODULE CONTENT */}
        <div className="card p-4 shadow-sm border-0">
          <h3 className="text-primary fw-bold">{activeModule}</h3>

          {/* REPORT */}
          {activeModule === "Report" ? (
            <>
              <div className="border rounded p-4 mt-3 d-flex align-items-center justify-content-between bg-light">
                <div>
                  <h5 className="mb-1">Report Access</h5>

                  <small className="text-muted">
                    Turn ON/OFF Report module
                  </small>
                </div>

                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={tempPermissions["Report"] || false}
                    onChange={() => handleToggle("Report")}
                  />
                </div>
              </div>
            </>
          ) : tempPermissions[activeModule] ? (
            <>
              <p className="mt-3">Welcome to {activeModule} module.</p>

              <div className="alert alert-success">✅ Access Granted</div>
            </>
          ) : (
            <div className="alert alert-danger mt-3">
              ❌ No access to this module
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default ASuperAdmin;
